import React, { useRef, useEffect, useState } from 'react'
import capitalize from 'lodash/capitalize'
import classnames from 'classnames'

import {
  IAccountUser,
} from '@SiteModules/AccountUser/types'

import './AccountUserRow.scss'

interface AccountUserRowProps {
  readonly index: number
  readonly accountUser: IAccountUser
  readonly selected: boolean
  readonly isOwnUser: boolean
  changeSelectedAccountUsers(e: React.ChangeEvent<HTMLInputElement>, accountUserId: number): void
  setOpenedAccountUserId(openedAccountUserId: number): void
}

const AccountUserRow: React.FC<AccountUserRowProps> = props => {
  const {
    index,
    selected,
    accountUser,
    isOwnUser,
  } = props

  const {
    id,
    attributes,
  } = accountUser

  const {
    createdAt,
    email,
    role,
    name,
    avatarUrl,
    userId,
  } = attributes

  const [hovering, setHovering] = useState(false)
  const checkboxRef = useRef<HTMLLabelElement | null>(null)
  const lastDigitOfUserId = userId % 10

  useEffect(() => {
    if (selected) {
      checkboxRef.current?.style?.setProperty('visibility', 'visible')
    } else if (!hovering) {
      checkboxRef.current?.style?.setProperty('visibility', 'hidden')
    }
  }, [selected])

  const onMouseEnter = () => {
    checkboxRef.current?.style?.setProperty('visibility', 'visible')
    setHovering(true)
  }

  const onMouseLeave = () => {
    setHovering(false)
    if (selected) { return }

    checkboxRef.current?.style?.setProperty('visibility', 'hidden')
  }

  const handleAccountUserSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.changeSelectedAccountUsers(e, id)
  }

  const handleOpenAccountUser = () => {
    props.setOpenedAccountUserId(id)
  }

  const renderCheckbox = () => {
    return (
      <label className="AccountUsersTable__checkbox" ref={checkboxRef}>
        <input
          type="checkbox"
          onChange={handleAccountUserSelection}
          checked={selected}
        />
        <div className="AccountUsersTable__checkmark" />
      </label>
    )
  }

  return (
    <tr
      className={classnames(
        { 'AccountUserRow__even': index % 2 === 0 },
        { 'AccountUserRow__uneven': index % 2 === 1 }
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <td className="AccountUsersTable__check">
        {renderCheckbox()}
      </td>
      <td
        className="AccountUsersTable__user AccountUserRow__user AccountUserRow__link"
        onClick={handleOpenAccountUser}
      >
        <div className="AccountUserRow__user-wrapper">
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt={name}
              className="AccountUserRow__avatar"
            />
          ) : (
            <div
              className={classnames(
                'AccountUserRow__avatar-placeholder',
                `AccountUserRow__avatar-placeholder-background-${lastDigitOfUserId}`
              )}
            >
              {name.length > 0 ? name.charAt(0) : email.charAt(0)}
            </div>
          )}
          <div className="AccountUserRow__user-name">
            {name.length > 0 ? name : email}
          </div>
          <div>
            {isOwnUser && ' (you)'}
          </div>
        </div>
      </td>
      <td
        className="AccountUsersTable__email AccountUserRow__email AccountUserRow__link"
        onClick={handleOpenAccountUser}
      >
        {email}
      </td>
      <td
        className="AccountUsersTable__joined-on AccountUserRow__joined-on AccountUserRow__link"
        onClick={handleOpenAccountUser}
      >
        {createdAt}
      </td>
      <td
        className="AccountUsersTable__role AccountUserRow__role AccountUserRow__link"
        onClick={handleOpenAccountUser}
      >
        <div
          className={classnames(
            'AccountUserRow__role-badge',
            { 'AccountUserRow__role-badge-admin': role === 'admin' },
            { 'AccountUserRow__role-badge-member': role === 'member' }
          )}
        >
          {capitalize(role)}
        </div>
      </td>
    </tr>
  )
}

export default AccountUserRow
